import { BASIC_UNIT_PRICE_CONSTANT } from '@/constants'
import I18n from '@/i18n'

export const basicUnitPrice = (recommendedRentFee, roomArea) => {
  const basicUnitPrice = recommendedRentFee / (roomArea * BASIC_UNIT_PRICE_CONSTANT)

  return I18n.n(Math.round(basicUnitPrice))
}
